import { registerFeature } from '../operationRegistry';
import { api } from '../../api';

export function registerFavoriteOperations(): void {
  registerFeature({
    name: 'favorites',
    invalidateKeys: [['favorites'], ['favorite-groups']],
    operations: [
      {
        type: 'FAVORITE_TOGGLE',
        collapseRule: 'cancelPair',
        cancelPairType: 'FAVORITE_TOGGLE',
        collapseKeyFn: (p) => `fav:${p.productId}`,
        async execute(payload) {
          const result = await api<{ favorited: boolean; product_id: number; favorite_id?: number }>(
            '/favorites/toggle',
            { method: 'POST', body: JSON.stringify({ product_id: payload.productId }) },
          );
          return result.favorite_id ? { id: result.favorite_id } : undefined;
        },
      },
      {
        type: 'FAVORITE_GROUP_CREATE',
        collapseRule: 'dropIfParentDeleted',
        async execute(payload) {
          return api<{ id: number }>('/favorite-groups', {
            method: 'POST',
            body: JSON.stringify({ name: payload.name }),
          });
        },
        extractId: (res: unknown) => (res as { id: number }).id,
      },
      {
        type: 'FAVORITE_GROUP_RENAME',
        collapseRule: 'lastWins',
        collapseKeyFn: (p) => `favgroup:${p.groupId}`,
        async execute(payload) {
          await api(`/favorite-groups/${payload.groupId}`, {
            method: 'PUT',
            body: JSON.stringify({ name: payload.name }),
          });
          return undefined;
        },
      },
      {
        type: 'FAVORITE_GROUP_DELETE',
        collapseRule: 'none',
        isEntityDelete: true,
        entityIdField: 'groupId',
        async execute(payload) {
          await api(`/favorite-groups/${payload.groupId}`, { method: 'DELETE' });
          return undefined;
        },
      },
      {
        type: 'FAVORITE_GROUP_MEMBER_ADD',
        collapseRule: 'cancelPair',
        cancelPairType: 'FAVORITE_GROUP_MEMBER_REMOVE',
        collapseKeyFn: (p) => `grpmember:${p.groupId}:${p.favoriteId}`,
        parentIdField: 'groupId',
        async execute(payload) {
          await api(`/favorite-groups/${payload.groupId}/favorites`, {
            method: 'POST',
            body: JSON.stringify({ favorite_id: payload.favoriteId }),
          });
          return undefined;
        },
      },
      {
        type: 'FAVORITE_GROUP_MEMBER_REMOVE',
        collapseRule: 'cancelPair',
        cancelPairType: 'FAVORITE_GROUP_MEMBER_ADD',
        collapseKeyFn: (p) => `grpmember:${p.groupId}:${p.favoriteId}`,
        parentIdField: 'groupId',
        async execute(payload) {
          await api(`/favorite-groups/${payload.groupId}/favorites/${payload.favoriteId}`, {
            method: 'DELETE',
          });
          return undefined;
        },
      },
    ],
  });
}
